"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const inputRecipe = tv({
  base: [
    "appearance-none bg-transparent border border-border-default rounded-none",
    "text-fg-default outline-none relative w-full",
    "transition-[box-shadow,border-color] duration-200",
    "disabled:opacity-40 disabled:cursor-not-allowed",
    "focus:border-neutral-default focus:shadow-[0_0_0_1px_var(--iap-colors-neutral-default)]",
    "aria-invalid:border-fg-error",
    "aria-invalid:focus:border-fg-error aria-invalid:focus:shadow-[0_0_0_1px_var(--iap-colors-border-error)]"
  ],
  variants: {
    size: {
      "2xs": "px-1.5 h-7 min-w-7 text-xs leading-[1.125rem]",
      xs: "px-2 h-8 min-w-8 text-xs leading-[1.125rem]",
      sm: "px-2.5 h-9 min-w-9 text-sm leading-5",
      md: "px-3 h-10 min-w-10 text-base leading-6",
      lg: "px-3.5 h-11 min-w-11 text-base leading-6",
      xl: "px-4 h-12 min-w-12 text-lg leading-7",
      "2xl": "px-[1.125rem] h-16 min-w-16 text-3xl leading-[2.375rem]"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const Input = forwardRef(({ className, size, ...props }, ref) => /* @__PURE__ */ jsx("input", { ref, className: inputRecipe({ size, className }), ...props }));
Input.displayName = "Input";

export { Input };
